module.exports = __webpack_public_path__ + "img/icon_k-line-style.d42b162b.svg";